(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvBoolInput', drvBoolInput);

    /**
     * @ngdoc directive
     * @name drvBoolInput
     * @description Input control for boolean field types
     *
     * @param {bool} value 
     * @param {object} field - An entity field object with properties such as 'HelpText', 'Mandatory', etc.
     */
    function drvBoolInput() {
        return {
            templateUrl: 'app/fieldinput/bool-input.tmpl.html',
            require: 'ngModel',
            scope: {},
            controller: drvBoolInputCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                value: '=ngModel',
                field: '='
            }
        };
    }

    drvBoolInputCtrl.$inject = [];

    function drvBoolInputCtrl() {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.showSuffix = showSuffix;

        function showSuffix() {
            return !_.isNil(drvCtrl.field) && !_.isNil(drvCtrl.field.Suffix) && drvCtrl.field.Suffix !== '';
        }
    }
})();